export const Colors = {
  primary: "#557eff",
};
